import { render, staticRenderFns } from "./SchoolOfHLRM.vue?vue&type=template&id=3525dafa"
import script from "./SchoolOfHLRM.vue?vue&type=script&lang=js"
export * from "./SchoolOfHLRM.vue?vue&type=script&lang=js"
import style0 from "./SchoolOfHLRM.vue?vue&type=style&index=0&id=3525dafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports